import * as utils from "common/utils";

export const gas = {
    methane: {
        name: "Methane",
        colour: { name: utils.getColour(4), hex: utils.colourHexIndex[4] },
    },
    nitrousOxide: {
        name: "Nitrous oxide",
        colour: { name: utils.getColour(0), hex: utils.colourHexIndex[0] },
    },
    carbonDioxide: {
        name: "Carbon dioxide",
        colour: { name: utils.getColour(9), hex: utils.colourHexIndex[9] },
    },
}
